import { defineComponent as _defineComponent } from 'vue';
import { useUpdateUserInputMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'GeographiesOptions',
  props: {
    userInput: {
      type: Object,
      default: function _default() {}
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUpdateUserInputMu = useUpdateUserInputMutation(),
      updateUserInput = _useUpdateUserInputMu.mutate;
    var valueChange = function valueChange(value) {
      var values = props.isMultiple ? value : [value];
      updateUserInput({
        input: {
          id: props.userInput.id,
          geographyIds: values
        }
      });
    };
    var values = computed(function () {
      var _props$userInput$geog, _props$userInput$geog2, _props$userInput$geog3;
      return props.isMultiple ? (_props$userInput$geog = props.userInput.geographyIds) !== null && _props$userInput$geog !== void 0 ? _props$userInput$geog : [] : (_props$userInput$geog2 = (_props$userInput$geog3 = props.userInput.geographyIds) === null || _props$userInput$geog3 === void 0 ? void 0 : _props$userInput$geog3[0]) !== null && _props$userInput$geog2 !== void 0 ? _props$userInput$geog2 : null;
    });
    return {
      __sfc: true,
      props: props,
      updateUserInput: updateUserInput,
      valueChange: valueChange,
      values: values
    };
  }
});